import { useEffect } from 'react';
import { useIntl } from 'react-intl';

/**
 * The browser tab of a document: its kind and its number, "Rechnung AR26-06924",
 * or "Rechnung Entwurf" while it has none. Never the internal id — the tab said
 * "Rechnungen 74757", a number no one could look up (#2316).
 */
export const PaloDocumentTitle = ({ typeId, number }: { typeId: string; number?: string | null }): null => {
    const intl = useIntl();

    useEffect(() => {
        const kind = intl.formatMessage({ id: typeId });
        const shown = number || intl.formatMessage({ id: 'app.convertReceipt.draft' });

        document.title = `${kind} ${shown}`;
    }, [typeId, number, intl]);

    return null;
};
